import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { toErrorMessage } from "../../lib/errors";
import SEO from "../../components/SEO";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/auth/me").then(() => navigate("/admin")).catch(() => {});
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data.token) localStorage.setItem("bcp_token", data.token);
      api.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
      navigate("/admin");
    } catch (err) {
      setError(toErrorMessage(err, "Invalid credentials"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <SEO title="Admin" description="" path="/admin/login" noindex />
    <div className="min-h-screen bg-ink text-cream-light flex items-center justify-center p-6 grain">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <div className="font-serif text-5xl tracking-tight mb-2">BCP</div>
          <div className="overline text-copper-light">Admin Panel</div>
        </div>

        <form onSubmit={submit} data-testid="admin-login-form" className="bg-ink-mid p-10 border border-copper/20">
          <h1 className="font-serif text-3xl mb-8 tracking-tight">Sign In</h1>
          <div className="space-y-6">
            <div>
              <label className="text-[10px] tracking-[0.24em] uppercase text-cream-light/60 mb-1 block">Email</label>
              <input
                data-testid="admin-email"
                type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                className="w-full bg-transparent border-b border-cream-light/25 focus:border-copper py-3 outline-none text-cream-light"
              />
            </div>
            <div>
              <label className="text-[10px] tracking-[0.24em] uppercase text-cream-light/60 mb-1 block">Password</label>
              <input
                data-testid="admin-password"
                type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                className="w-full bg-transparent border-b border-cream-light/25 focus:border-copper py-3 outline-none text-cream-light"
              />
            </div>
          </div>
          {error && <div data-testid="admin-login-error" className="text-red-400 text-sm mt-6">{error}</div>}
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="btn-copper w-full justify-center mt-10 disabled:opacity-50">
            {loading ? "Signing in..." : "Sign In →"}
          </button>
        </form>

        <a href="/" className="block text-center text-cream-light/50 text-xs uppercase tracking-[0.18em] mt-8 hover:text-copper-light">← Back to Site</a>
      </div>
    </div>
    </>
  );
}
